import script from "./console.vue?vue&type=script&setup=true&lang=ts"
export * from "./console.vue?vue&type=script&setup=true&lang=ts"

import "./console.vue?vue&type=style&index=0&id=fbd47b68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbd47b68"]])

export default __exports__